var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hide && !_vm.override)?_c('div',{on:{"click":function($event){_vm.override = true}}},[_vm._v(" Summary automatically hidden for unwatched content. Click to unhide. ")]):_c('div',[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }